import { addToast, Button } from '@octano/global-ui';
import { Col } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../locales/translations';
import { createReportDownloadHandler } from '../../reports/parts/ReportActionsCell/handlerCreator';
import { downloadFromBlob } from '../../../utils/blob';
import { useState } from 'react';

const downloadUrl = '/teacher-attendance';

interface DownloadReportProps {
  params: {
    sectionId?: number;
    classStatus?: string;
  };
  disableDownload: boolean;
}

export default function DownloadReport({
  params,
  disableDownload,
}: DownloadReportProps) {
  const { t } = useTranslation(TranslationsKeys.TEACHER_ATTENDANCE_LIST);
  const [loading, setLoading] = useState(false);

  const handleDownload = createReportDownloadHandler({
    beforeDownload: () => setLoading(true),
    afterDownload: ({ data }) => {
      setLoading(false);
      if (data?.size === 0) {
        addToast({
          icon: 'error',
          color: 'danger',
          text: t(`report.error`),
        });
      }
    },
    onSuccess: (data: Blob) => {
      if (data.size > 0) {
        const blob = new Blob([data], { type: 'vnd.ms-excel' });
        downloadFromBlob(blob, `asistencia-docente.xlsx`);
        setLoading(false);
        addToast({
          icon: 'success',
          color: 'success',
          text: t(`report.success`),
        });
      }
    },
    onError: () => {
      setLoading(false);
      addToast({
        icon: 'error',
        color: 'danger',
        text: t(`report.error`),
      });
    },
  });

  return (
    <Col xs={12} className="d-flex justify-content-end mb-4">
      <Button
        size="md"
        icon="download"
        color="primary"
        text={t(`report.btnDownload`)}
        onClick={() =>
          handleDownload(downloadUrl, {
            ...params,
          })
        }
        loading={loading}
        disabled={disableDownload}
        className="w-30"
      />
    </Col>
  );
}
